import { render, staticRenderFns } from "./LeftArrow.vue?vue&type=template&id=1bb3e272"
import script from "./LeftArrow.vue?vue&type=script&lang=js"
export * from "./LeftArrow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports